export const PATIENT_REQUEST = "PATIENT_REQUEST";
export const PATIENT_SUCCESS = "PATIENT_SUCCESS";
export const PATIENT_ERROR = "PATIENT_ERROR";

export const GET_CATEGORIES_REQUEST1 = "GET_CATEGORIES_REQUEST1";
export const GET_CATEGORIES_SUCCESS1 = "GET_CATEGORIES_SUCCESS1";
export const GET_CATEGORIES_ERROR1 = "GET_CATEGORIES_ERROR1";
export const GET_CATEGORIES_DONE1 = "GET_CATEGORIES_DONE1";

export const GET_CATEGORY_VIDEOS_REQUEST1 = "GET_CATEGORY_VIDEOS_REQUEST1";
export const GET_CATEGORY_VIDEOS_SUCCESS1 = "GET_CATEGORY_VIDEOS_SUCCESS1";
export const GET_CATEGORY_VIDEOS_ERROR1 = "GET_CATEGORY_VIDEOS_ERROR1";

export const GET_LNG_LAT_MAP_REQUEST = "GET_LNG_LAT_MAP_REQUEST";
export const GET_LNG_LAT_MAP_SUCCESS = "GET_LNG_LAT_MAP_SUCCESS";
export const GET_LNG_LAT_MAP_ERROR = "GET_LNG_LAT_MAP_ERROR";

export const GET_PLAYLIST_VIDEOS = "GET_PLAYLIST_VIDEOS";
export const GET_PLAYLIST_VIDEOS_ERROR = "GET_PLAYLIST_VIDEOS_ERROR";
export const GET_PLAYLIST_VIDEOS_SUCCESS = "GET_PLAYLIST_VIDEOS_SUCCESS";

export const GET_QRCODEVISITE_REQUEST = "GET_QRCODEVISITE_REQUEST";
export const GET_QRCODEVISITE_SUCCESS = "GET_QRCODEVISITE_SUCCESS";
export const GET_QRCODEVISITE_ERROR = "GET_QRCODEVISITE_ERROR";

export const patientRequest = (payload) => ({
  type: PATIENT_REQUEST,
  ...payload,
});

export const patientSuccess = (authData) => ({
  type: PATIENT_SUCCESS,
  authData,
});

export const patientError = () => ({
  type: PATIENT_ERROR,
});

export const getCategoriesRequest1 = (authData) => ({
  type: GET_CATEGORIES_REQUEST1,
  authData,
});

export const getCategoriesSuccess1 = (categories) => ({
  type: GET_CATEGORIES_SUCCESS1,
  categories,
});

export const getCategoriesError1 = (error) => ({
  type: GET_CATEGORIES_ERROR1,
  error,
});

export const getCategoriesDone1 = () => ({
  type: GET_CATEGORIES_DONE1,
});

export const getCategoryVideosRequest1 = (payload) => {
  console.log("getCategoryVideosRequest1", payload);
  return {
    type: GET_CATEGORY_VIDEOS_REQUEST1,
    ...payload,
  };
};

// Action to request google Map
export const getLngLatMapRequest = (lngLat) => {
  // console.log('Action lngLat request : ', lngLat)
  return {
    type: GET_LNG_LAT_MAP_REQUEST,
    lngLat,
  };
};

export const getLngLatMapError = (error) => {
  // console.log('Action lngLat error : ', error)
  return {
    type: GET_LNG_LAT_MAP_ERROR,
    error,
  };
};

export const getLngLatMapSuccess = (lngLat) => {
  // console.log('Action lngLat success : ', lngLat)
  return {
    type: GET_LNG_LAT_MAP_SUCCESS,
    lngLat,
  };
};

// END Action to request google Map

export const getPlaylistVideo = (playVideo) => ({
  type: GET_PLAYLIST_VIDEOS,
  playVideo,
});

export const getPlayListVideoError = (error) => ({
  type: GET_PLAYLIST_VIDEOS_ERROR,
  error,
});

export const getPlayListVideoSuccess = (playVideo) => ({
  type: GET_PLAYLIST_VIDEOS_SUCCESS,
  playVideo,
});

export const getCategoryVideosSuccess1 = (videos) => ({
  type: GET_CATEGORY_VIDEOS_SUCCESS1,
  videos,
});

export const getCategoryVideosError1 = (error) => ({
  type: GET_CATEGORY_VIDEOS_ERROR1,
  error,
});

export const getQrCodeVisiteRequest = (payload) => (
  console.log("Payload", payload),
  {
    type: GET_QRCODEVISITE_REQUEST,
    payload,
  }
);
export const getQrCodeVisiteSuccess = (subdomain) => (
  console.log("Subdomain", subdomain),
  {
    type: GET_QRCODEVISITE_SUCCESS,
    subdomain,
  }
);
export const getQrCodeVisiteError = (error) => (
  console.log("Error QrcodeVisited", error),
  {
    type: GET_QRCODEVISITE_ERROR,
    error,
  }
);



// WEBPACK FOOTER //
// ./src/pages/patientplaylist/actions.js